import client from '../httpClient';

// sms/customer【sms008】SMS顧客登録
const smsCustomerCreateApi = (obj) => {
  const CREATE_SMS_CUSTOMER_URL = '/sms/customer';
  return client.post(CREATE_SMS_CUSTOMER_URL, JSON.stringify(obj));
};

export default smsCustomerCreateApi;
